import { StripingSubSection } from './striping-sub-section'
import { MiscSection } from './misc-section'
import type { PricingItem, LineItem, CreateLineItemPayload } from '@/types'

const STRIPING_SECTIONS = [
  { id: 'School Striping', title: 'School Striping' },
  { id: 'Other Striping', title: 'Other Striping' },
  { id: 'Concrete Wheel Stops', title: 'Concrete Wheel Stops' },
  { id: 'Stencils', title: 'Stencils' },
  { id: 'Stalls', title: 'Stalls' },
  { id: 'ADA Stencils', title: 'ADA Stencils' },
]

interface StripingEstimatePanelProps {
  estimateId: string
  pricingItems: PricingItem[]
  lineItems: LineItem[]
  onAddItem: (payload: CreateLineItemPayload) => Promise<void>
  onUpdateItem: (itemId: string, data: Partial<CreateLineItemPayload> & { lineTotal?: number }) => Promise<void>
  onDeleteItem: (itemId: string) => Promise<void>
}

export function StripingEstimatePanel({
  pricingItems, lineItems, onAddItem, onUpdateItem, onDeleteItem,
}: StripingEstimatePanelProps) {
  return (
    <div className="ec-panel">
      {STRIPING_SECTIONS.map((sec) => (
        <StripingSubSection
          key={sec.id}
          title={sec.title}
          stripingCategory={sec.id}
          lineItems={lineItems}
          pricingItems={pricingItems}
          onAddItem={onAddItem}
          onUpdateItem={onUpdateItem}
          onDeleteItem={onDeleteItem}
        />
      ))}
      <MiscSection
        lineItems={lineItems}
        pricingItems={pricingItems}
        section="striping"
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
      />
    </div>
  )
}
